<template>
  <div class="currency-input">
    <el-input
      :placeholder="presentationMode ? $t('pay.tips-amount-presentation') : $t('pay.tips-amount')"
      class="currency-input-field"
      ref="inputRef"
      v-model="formattedValue"
    />
    <div
      v-if="formattedValue"
      class="currency-input-clear"
      @click="clearField"
    >
      <i class="el-icon-close" />
    </div>
  </div>
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    presentationMode: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { formattedValue, inputRef, setValue } = useCurrencyInput(props.options);

    return { inputRef, formattedValue, setValue };
  },
  watch: {
    value: function (value) {
      this.setValue(value);
    }
  },
  methods: {
    clearField () {
      this.setValue(undefined);
    }
  }
};
</script>
<style lang="scss">
.currency-input {
  position: relative;
  &-field {
    width: 100%;

    &:focus {
      outline: none;
      border-color: #FF8A00;
    }

    .el-input__inner {
      text-align: center;
      height: 60px;
      background: #F6F7F9;
      border: 1px solid #E3E5E6;
      border-radius: 8px;
      font-family: "Raleway Bold", serif;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: #2D2E2F;
      font-size: 24px;
      font-weight: bold;
    }
  }

  &-clear {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 50px;
    width: 50px;
    background: #FFFFFF;
    border-radius: 50%;

    i {
      position: absolute;
      top: 14px;
      right: 13px;
      cursor: pointer;

      &:before {
        font-size: 24px;
        color: #FF8A00;
        font-weight: bold;
      }
    }
  }
}
</style>
